import { slideToggle } from "js/function";
import { useRef, useState } from "react";

function IconInfoText(data){
    return (
        <div className={`iconInfoTextBox ${data.addClass ? data.addClass : ""}`} >
            <img src="/assets/images/icon/info.svg"/>
            <div className="iconInfoTextItem">
                <h2 className="iconInfoName" dangerouslySetInnerHTML={{__html:data.name}}/>
                <p className="iconInfoText" dangerouslySetInnerHTML={{__html:data.text}}/>
            </div>
        </div>
    );
}

function FixedBox_btnItem(data){
    return (
        <button type="button" onClick={()=>{data.func()}} className={`fixedBox_btnItem ${data.addClass ? data.addClass : ""}`} disabled={data.disabled ? data.disabled : false}>
            <div className="fixedBox_btnItemTextBox">
                {data.icon ? <img src={data.icon}/> : ""}
                <p className="fixedBox_btnItemText" dangerouslySetInnerHTML={{__html:data.text}}/>
            </div>
            <img src="/assets/images/basic/move_w.svg"/>
        </button>
    );
}

function FixedBox_chkItemBox(data){
    const slideItem = useRef(null);
    const [openChk,setOpenChk] = useState(true);
    
    const [slideChk,setSlideChk] = useState(true);

    function onChangeEvn(val,name){
        if(data.multiple){
            let oldData = data.value && data.value !== "" ? [...data.value] : [];
            let setData = [];

            if(data.allChk && (val === "" || !val)){
                data.func("");
            }else if(oldData.filter((el)=>el === val).length > 0){
                setData = oldData.filter((el)=>el !== val);
                data.func(setData);
            }else{
                setData = [...oldData,val];
                data.func(setData);
            }
        }else{
            data.func(val,name);
        }
    };

    return (
        <div className={`fixedBox_chkItemBox ${data.addClass ? data.addClass : ""} ${data.slideItem ? "fixedBox_chkItemSlideBox" : ""} ${openChk ? "active" : ""}`} disabled={data.disabled ? data.disabled : false}>
            {data.title ? 
            <div className="fixedBox_chkItemTitleBox" onClick={()=>{
                if(slideChk && data.slideItem){
                    setSlideChk(false);
                    setTimeout(function(){
                        slideToggle(slideItem.current,"block")
                        setOpenChk(!openChk)
                    },0);
                    setTimeout(() => {
                        setSlideChk(true);
                    }, 300);
                }
            }}>
                <h2 className="fixedBox_chkItemTitle" dangerouslySetInnerHTML={{__html:data.title}}/>
                {data.slideItem ? <img src="/assets/images/basic/sel.svg"/> : ""}
            </div>
            :""}
            <div className={`fixedBox_chkItemList ${data.alignType||""}`} ref={slideItem}>
                {data.allChk ? 
                <button type="button" className={`fixedBox_chkItem fixedBox_chkItemAll ${data.value === "" || data.value == null ? "active" : ""}`} onClick={()=>{data.func("")}}>
                    <div className="fixedBox_chkItem_chk"/>
                    <div className="fixedBox_chkItem_textBox">
                        <h2 className="fixedBox_chkItem_name">전체</h2>
                    </div>
                </button>
                :""}
                {data.data?.map((item,i)=>(
                    <button type="button" key={i} className={`fixedBox_chkItem ${data.multiple ? data.value && data.value !== "" && data.value.filter((el)=>el === item.id).length > 0 ? "active" : "" : data.value === item.id ? "active" : ""}`} onClick={()=>{onChangeEvn(item.id,item.name)}}>
                        <div className="fixedBox_chkItem_chk"/>
                        <div className="fixedBox_chkItem_textBox">
                            <h2 className="fixedBox_chkItem_name" dangerouslySetInnerHTML={{__html:item.name}}/>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
}

function TermsPopupSubTitle(data){
    return (
        <h2 className="termsPopupSubTitle" dangerouslySetInnerHTML={{__html:data.title}}/>
    );
}

export {IconInfoText,FixedBox_btnItem,FixedBox_chkItemBox,TermsPopupSubTitle};